import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assigned-attempt',
  templateUrl: './assigned-attempt.component.html',
  styleUrls: ['./assigned-attempt.component.scss']
})
export class AssignedAttemptComponent implements OnInit {

  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;
  
 
  showDetailsEvent() {
    this.showDetails = !this.showDetails;       
    }
  ngOnInit(): void {
   

  }
  closeResult = '';

  constructor(private modalService: NgbModal) {}

  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }

}
